module.exports = __webpack_public_path__ + "static/media/santiye_360_logo3.6de3d640.png";